






























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class AcordionLike extends Vue {
  @Prop({ default: 'out-in' })
  mode: string
}
